import React from "react";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { EditButton } from "../button/EditButton.js";
import { useEditButton } from "./hooks.js";
const useClasses = makeStyles()((theme) => ({
  withEditButtonContainer: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    flexGrow: 1,
    justifyContent: "space-between",
    columnGap: theme.spacing(1)
  }
}));
const withEditButton = (WrappedComponent) => ({
  mode,
  onEdit,
  onSave,
  onCancel,
  disabled = false,
  isMultiStep = false,
  onNextStep,
  onEditModeChange,
  disabledSubmitButton,
  ...props
}) => {
  const { classes } = useClasses();
  const { currentMode, handleSave, handleCancel, handleEdit, handleNextStep } = useEditButton({
    mode,
    isMultiStep,
    onEdit,
    onSave,
    onCancel,
    onNextStep,
    onEditModeChange
  });
  return /* @__PURE__ */ React.createElement(Box, { "data-testid": "editContainer", className: classes.withEditButtonContainer }, /* @__PURE__ */ React.createElement(WrappedComponent, { ...props, mode: currentMode }), !disabled ? /* @__PURE__ */ React.createElement(
    EditButton,
    {
      mode: currentMode,
      onSave: handleSave,
      onCancel: handleCancel,
      onEdit: handleEdit,
      onNextStep: handleNextStep,
      disabled: props.loading,
      disabledSubmitButton
    }
  ) : /* @__PURE__ */ React.createElement(React.Fragment, null));
};
export {
  withEditButton
};
//# sourceMappingURL=EditButtonHoc.js.map
